import { render, staticRenderFns } from "./YAxis.vue?vue&type=template&id=2ed7f2a7&scoped=true&"
import script from "./YAxis.vue?vue&type=script&lang=js&"
export * from "./YAxis.vue?vue&type=script&lang=js&"
import style0 from "./YAxis.vue?vue&type=style&index=0&id=2ed7f2a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed7f2a7",
  null
  
)

export default component.exports